module.exports = __webpack_public_path__ + "img/dislike.9b947c04.svg";